import { Fragment } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import remarkBreaks from 'remark-breaks';

import { capitalizeFirstLetter } from '@lib/core/service/utils';

type Props = Omit<Options, 'children'> & {
  text: string | number | JSX.Element;
  transformText?: 'default' | 'none' | 'custom-pmi' | 'lowercase';
};

const CustomMDReactComponent = ({ text = '', transformText = 'default', ...rest }: Props) => {
  const transformedText = (() => {
    const textStr = String(text);

    let modifiedText = transformText === 'default' ? capitalizeFirstLetter(textStr) : textStr;

    if (modifiedText.includes('||') || transformText === 'custom-pmi') {
      modifiedText = modifiedText.replace(/\|\|/g, '  \n');
    }

    return modifiedText;
  })();

  const components = {
    a: ({ ...props }) => (
      <a {...props} rel="noopener noreferrer" target="_blank">
        {props.children}
      </a>
    ),
    p: Fragment,
  };

  return (
    <ReactMarkdown components={components} remarkPlugins={[remarkBreaks]} {...rest}>
      {transformedText}
    </ReactMarkdown>
  );
};

export default CustomMDReactComponent;
